import classNames from "classnames";

import styles from "./Switch.module.css";

type Props = {
  className?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export default function Switch(props: Props) {
  return (
    <label className={classNames(styles.switch, props.className)}>
      <input
        type="checkbox"
        checked={props.checked}
        onChange={(event) => props.onChange(event.target.checked)}
      />
      <span className={classNames(styles.slider)} />
    </label>
  );
}
